import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const Bid = React.lazy(() => import("../page/Bid"));

const routes: AppRouteType[] = [
  {
    path: slugs.bid,
    component: Bid,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
